module.exports = __webpack_public_path__ + "media/coffee-preferences/roast_dark-fa98ab06.png";